export function isUnconfirmedUserPasswordReset (error) {
  return error.message === 'Cannot reset password for the user as there is no registered/verified email or phone_number'
}

export function isUnconfirmedLogin (error) {
  return error.code === 'UserNotConfirmedException'
}

export function isUnauthorizedUser (error) {
  return error.code === 'NotAuthorizedException'
}
